export default "__VITE_ASSET__77672ed6__"